import React from 'react';
import { useTranslation } from 'react-i18next';
import ScheduleWarningCancelButton from '../atoms/ScheduleWarningCancelButton';
import ScheduleWarningConfirmButton from '../atoms/ScheduleWarningConfirmButton';
import ScheduleWarningFixNowButton from '../atoms/ScheduleWarningFixNowButton';
import { getScheduleButtonText } from '../utils/helpers';

interface ScheduleWarningFooterProps {
  onCancel?: () => void;
  onToggle?: () => void;
  onOk: () => void;
  isOptimizing: boolean;
  isPublished: boolean;
  showCancel: boolean;

}

const ScheduleWarningFooter: React.FC<ScheduleWarningFooterProps> = ({
  onCancel,
  onToggle,
  onOk,
  isOptimizing,
  isPublished,
  showCancel,
}) => {
  const { t } = useTranslation('components');

  return (
    <>
      {showCancel && (
        <ScheduleWarningCancelButton
          onClick={onCancel}
          text={t('reoptimizeRouteConfirmModal.cancel')}
        />
      )}
      {onToggle && (
        <ScheduleWarningFixNowButton
          onToggle={onToggle}
          text={t('unscheduledVisits.scheduleWarningModal.reviewWarnings')}
        />
      )}
      <ScheduleWarningConfirmButton
        onOk={onOk}
        isOptimizing={isOptimizing}
        text={getScheduleButtonText(t, isOptimizing, isPublished)}
      />
    </>
  );
};

export default ScheduleWarningFooter;
